import * as preact from "preact";

import * as deviceDetect from "deviceDetect";
import * as genericModals from "genericModals";
import AppPremiumPageView from "pages/AppPremiumPageView";
import { type PreactPageProps } from "pages/PreactPage";
import stores from "stores/stores";
import { AccountPanel } from "views/AccountPanelView2";
import ManageSubscriptionView from "views/ManageSubscriptionView";

export default class AccountPageView extends preact.Component<PreactPageProps> {
  /**
   * The Checkout route's redirects land here, and both of them can arrive for
   * a user who is NOT premium yet — a first-time subscriber whose completed
   * session hasn't been accepted sees the pricing panel below, not the
   * subscription manager — so the explanation lives at the page level.
   */
  componentDidMount() {
    const query = new URLSearchParams(window.location.search);

    // A grant too far in the future to be represented as a Stripe trial, so
    // no bridge could be opened for it.
    if (query.get("bridgeUnavailable")) {
      genericModals.alert({
        title: "Subscription not available yet",
        message:
          "Your premium access runs too far into the future to start a " +
          "subscription against it. We'll email you a link to subscribe " +
          "once your access ends.",
        buttons: [{ name: "ok", displayName: "OK" }],
      });
    }

    // The user already completed a payment whose webhook hasn't landed yet —
    // no second checkout may be opened.
    if (query.get("checkoutProcessing")) {
      genericModals.alert({
        title: "Payment being processed",
        message:
          "Your recent payment is still being processed — your " +
          "subscription will appear here within a few minutes. If it " +
          "doesn't, please contact steve@readlang.com.",
        buttons: [{ name: "ok", displayName: "OK" }],
      });
    }
  }

  render() {
    return (
      <div class="accountPanelView">
        {stores.user.hasPremiumAccess.value ? (
          <ManageSubscriptionView />
        ) : deviceDetect.isIOSApp() ? (
          // The App Store's plans, as Apple requires in the app
          <AppPremiumPageView {...this.props} />
        ) : (
          <AccountPanel accountPage={true} smartDefinitions={true} />
        )}
      </div>
    );
  }
}
